<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-组织类型-添加
    -->
    <el-dialog
    title="添加组织类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加组织类型</div>

      <el-form-item label="组织类型名称" prop="name"><el-input v-model="form.name" placeholder="请输入组织类型名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import Organization_typeApi from '@/api/organization_type.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入组织类型名称', trigger: 'blur' }],
      },
      dialogVisible: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Organization_typeApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/organization_type/index/part/add.vue